import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Conversion } from '../../shared/components/ConversionMF';
import { Deposit } from '../../shared/components/DepositMF';
import { Withdraw } from '../../shared/components/WithdrawMF';
import { useAuthenticationStatus } from '../../shared/hooks/user';

import { OldContainer } from './OldContainer';

export const ModalsContainer: React.FC = () => {
  const isAuthenticated = useAuthenticationStatus();
  return (
    <Switch>
      {isAuthenticated && <Route path="*/deposit" component={Deposit} />}
      {isAuthenticated && <Route path="*/withdraw" component={Withdraw} />}
      {isAuthenticated && <Route path="*/conversion" component={Conversion} />}
      <Route component={OldContainer} />
    </Switch>
  );
};
